import React from 'react';
import { Select } from "antd";
import { IEmployeeSelectView } from "./type/employee-select.types";


const EmployeeSelectView: React.FC<IEmployeeSelectView> = (props) => {

    function handleKeyDown(e: React.KeyboardEvent<HTMLInputElement>) {
        //it will call search api when enter is pressed
        if (e.key === 'Enter') {
            //to stop dropdown from closing on pressing enter
            e.preventDefault();
            e.stopPropagation();
            //detect the enter key event
            const value = (e.target as HTMLInputElement).value;
            //call the search api with given string
            props.handleSearch(value);
        }
    }


    function handleScroll(e: React.UIEvent<HTMLDivElement>) {
        const el = e.target as HTMLElement;
        if (props.paginationControls.isLoading) return;

        const isAtTop = el.scrollTop <= 5;
        const isAtBottom =
            el.scrollTop + el.clientHeight >= el.scrollHeight - 5;

        if (isAtTop && props.paginationControls.hasPrevious) {

            props.paginationControls.loadPrevious();
        }

        if (isAtBottom && props.paginationControls.hasNext) {

            props.paginationControls.loadNext();
        }
    }

    return (
        <Select
            disabled={props.disabled??false}
            value={props.selectedId ?? undefined}
            showSearch
            className={'employee-select'}
            popupClassName="employee-select-dropdown"
            autoClearSearchValue={false}
            filterOption={false}
            onChange={(val: string) => props.handleChange(val)}
            onPopupScroll={handleScroll}
            onInputKeyDown={handleKeyDown}
            onDropdownVisibleChange={props.handleDropdownClose}
            placeholder={props.placeholderText}
        >
            {props.includeAllEmployeeOption && <Select.Option key={''} value={''}>All Employee</Select.Option>}
            {props.data.map((emp) => (
                <Select.Option key={emp.id} value={emp.id}>
                    <div className="employee-option">
                        <span className="name">{emp.name}</span>
                        <span className={`designation ${emp.designation?'':'hide'}`}>{emp.designation}</span>
                    </div>
                </Select.Option>
            ))}
        </Select>
    )

}
export default EmployeeSelectView
